<template>
  <v-flex xs12 row>
    <v-layout py-3>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            
            <autocomplete
              v-model="filter.period"
              label="Time Period"
              search-key="type"
              :items="$options.periods"
            />
            
            <date-picker 
              v-if="filter.period === 'monthly'" 
              v-model="filter.year_month" 
              :min="minDateFrom" 
              :max="maxDate" 
              label="Year & Month" 
              class="mr-3" 
              type="month" 
            />

            <date-picker 
              v-else 
              v-model="filter.date_from" 
              :min="minDateFrom" 
              :max="maxDate" 
              :label="dateFromLabel" 
              class="mr-3" 
            />

            <date-picker 
              v-if="hasDateTo" 
              v-model="filter.date_to" 
              :disabled="!isDateToEditable"
              :min="minDateTo" 
              :max="maxDateTo" 
              label="Date To" 
              class="mr-3"
            />
            
            <autocomplete 
              v-model="filter.purchase_type"
              label="Type"
              :items="$options.types"
            />

            <autocomplete
              v-if="filter.purchase_type == $options.purchaseTypes.product"
              async
              clearable
              v-model="filter.item"
              label="Item Code"
              sub-title="title"
              search-key="item_code"
              key="itemByCode"
              :api-path="config.apis.searchItems"
            />

            <autocomplete
              v-if="filter.purchase_type == $options.purchaseTypes.rawmaterial"
              async
              clearable
              v-model="filter.item"
              label="Raw Material"
              search-key="title"
              key="itemByName"
              :api-path="config.apis.searchRawMaterials"
            />

            <search-btn @click="loadReport" />

            <v-spacer></v-spacer>

          </v-card-title>

          <data-table
            :headers="headers"
            :items="processedItems"
            :loading="processing"
            :title="resultTitle"
            :sheet-name="sheetName"
            hide-actions
            download
          ></data-table>

      </v-card>
      </v-flex>
    </v-layout>
    
  </v-flex>
</template>

<script>

  import sumBy from 'lodash/sumBy'

  import { reports } from '../../config/apis'
  import purchaseTypes from '../../config/purchaseTypes'

  import reportMixin from '../../mixins/reports'

  import DataTable from '../../components/DataTable'
  import DatePickerDialog from '../../components/DatePickerDialog'

  export default {
    
    components: {
      'data-table': DataTable,
      'date-picker': DatePickerDialog,
    },

    mixins: [ 
      reportMixin,
    ],

    data () {
      return {
        title: "Item Wise Purchase Report",
        reportsApiPath: reports.itemPurchase,
        filter: {
          period: "daily",
          date_from: this.today('YYYY-MM-DD'),
          date_to: '',
          year_month: '',
          purchase_type: purchaseTypes.product,
          item: null
        },
        hasDateWiseReport: false,
      }
    },

    computed: {
    	
      processedItems() {
          
        return this.items.map(item => {

          return {
            item_code: item.item_code,
            item_name: item.item_name,
            unit_name: item.unit_name,
            item_count: item.item_count,
            item_total: item.item_total,
          }

        })
        
      },

    },

    watch: {
      'filter.purchase_type': function(newVal) {
        this.items = []
      }
    },

    created () {

      this.$options.purchaseTypes = purchaseTypes

      let types = []

      for (const [key, val] of Object.entries(this.$options.purchaseTypes)) {
        types.push({id: val, title: key})
      }

      this.$options.types = types

      this.$options.itemWiseHeaders = [
        { text: 'Item Code', value: 'item_code', sortable: false },
        { text: 'Item Name', value: 'item_name', sortable: false },
        { text: 'Unit', value: 'unit_name', sortable: false },
        { text: 'Purchase Count', value: 'item_count', customFilter: 'roundValue', sortable: false, align: 'right' },
        { text: 'Total Amount', value: 'item_total', customFilter: 'roundValue', sortable: false, align: 'right' },
      ]

    },

  }
</script>
